export default {"src":"/_next/static/media/pin.6b21806b.svg","height":20,"width":16};